// extracted by mini-css-extract-plugin
export default {"form":"CreateAccount_form__0Q9mH","formGroup":"CreateAccount_formGroup__k5h5d"};